import { render, staticRenderFns } from "./PriceTableIL.vue?vue&type=template&id=06df07a6&"
import script from "./PriceTableIL.vue?vue&type=script&lang=js&"
export * from "./PriceTableIL.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports